import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from '@etherisc/ui-kit';
import { farmerService } from '../../services/farmerService';
import { ApiError } from '../../utils/errorHandling';
import { FarmerForm } from '../../components/farmer';
import type { FarmerFormData } from '../../types/farmer';

export function CreateFarmer() {
  const navigate = useNavigate();
  
  const showSuccess = useCallback((title: string, description: string) => {
    return toast.success(title, { description });
  }, []);

  const showError = useCallback((title: string, description: string) => {
    return toast.error(title, { description });
  }, []);

  const handleSubmit = useCallback(async (data: FarmerFormData) => {
    try {
      const response = await farmerService.createFarmer(data);
      
      if (response.farmer) {
        showSuccess(
          'Farmer Created Successfully',
          `${response.farmer.name} has been added to the system with farmer code ${response.farmer.farmerCode}.`
        );
        navigate('/admin/farmers');
      } else {
        throw new Error('No farmer data received from server');
      }
    } catch (error) {
      console.error('Error creating farmer:', error);
      
      if (error instanceof ApiError) {
        showError('Failed to Create Farmer', error.message);
      } else {
        const errorMessage = error instanceof Error ? error.message : 'An unexpected error occurred';
        showError('Failed to Create Farmer', errorMessage);
      }
    }
  }, [navigate, showSuccess, showError]);

  const handleCancel = useCallback(() => {
    navigate('/admin/farmers');
  }, [navigate]);

  return (
    <FarmerForm
      mode="create"
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      title="Create Farmer"
      subtitle="Add a new farmer to the system"
    />
  );
}